import { render, staticRenderFns } from "./SkvAcademy.vue?vue&type=template&id=da9cb26e&scoped=true"
import script from "./SkvAcademy.vue?vue&type=script&lang=js"
export * from "./SkvAcademy.vue?vue&type=script&lang=js"
import style0 from "./SkvAcademy.vue?vue&type=style&index=0&id=da9cb26e&prod&lang=scss&scoped=true"
import style1 from "./SkvAcademy.vue?vue&type=style&index=1&id=da9cb26e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9cb26e",
  null
  
)

export default component.exports